const HeaderMenuSlider = () => {
  document.querySelectorAll('.full-menu--promotion-carousel__wrapper')?.forEach(el => {
    const sw = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 20
    })
  })
}

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 767) {
    HeaderMenuSlider();
  }
});

const setFrame = (url) => {
  $('.variants-selector--frame .variant-image-frame').css('--background-image', `url("${url}")`);
}

const getShape = (size, input) => {
  let x = parseInt(size.split("x")[0]);
  let y = parseInt(size.split("x")[1]);
  let url = "";
  let z = y / x;

  if (z > 1.1 && z < 1.3) {
    url = input.dataset.classicVertical;
  } else if (z > 0.75 && z < 0.85) {
    url = input.dataset.classicHorizontal;
  } else if (z > 2.5 && z < 3.5) {
    url = input.dataset.panoVertical;
  } else if (z > 0.3 && z < 0.4) {
    url = input.dataset.panoHorizontal;
  } else if (z > 0.6 && z < 0.7) {
    url = input.dataset.rectangleHorizontal;
  } else if (z > 1.4 && z < 1.6) {
    url = input.dataset.rectangleVertical;
  } else if (z == 1) {
    url = input.dataset.square;
  } else if (z > 0.4 && z < 0.6) {
    url = input.dataset.storyHorizontal;
  } else {
    console.log("Wrong Size!!!");
  }

  setFrame(url);

  return {x, y};
}

$(document).ready(function () {
  $(document).on("click", ".filter-sidebar--opener", function () {
    $(".collection-container .facets--bar").toggle();
    $(".sidebar-filter").toggleClass('open');
    $(".collection-container .facets--bar").next().find('#product-grid').toggleClass('medium-up-4')
  });

  $(document).on("click", ".collection-container .filter-label", (event) => {
    $(event.target).next().slideToggle();
    $(event.target).toggleClass('active');
  });

  $(".variants-selector--frame .variant-frame--selected-value").text($('.variants-selector--frame input:checked').data("value"));
  $(".variants-selector--frame .finshed-size-value").text($('fieldset[data-handle="size"] input:checked').val());

  $(".variants-selector--frame input").change((e) => {
    $("fieldset[data-handle='frame'] input[value='Premium']").click();
    $(".variants-selector--frame .variant-frame--selected-value").text(e.target.dataset.value);
    // var selectedSize = $('fieldset[data-handle="size"] input:checked').val();
    var {x, y} = getShape($('fieldset[data-handle="size"] input:checked').val(), e.target);
    $(".variants-selector--frame .finshed-size-value").text(`${x + parseFloat(e.target.dataset.size)}x${y + parseFloat(e.target.dataset.size)}`);
    // $('.variants-selector--frame .variant-image-frame').css('--background-image', `url("${e.target.dataset.frame}")`);
  });

  $('fieldset[data-handle="size"] input').change((e) => {
    if (document.querySelector('.variants-selector--frame input:checked')) {
      getShape(e.target.value, document.querySelector('.variants-selector--frame input:checked'));
    }
    $(".variants-selector--frame .finshed-size-value").text(e.target.value);
  });

  $('fieldset[data-handle="frame"] input, fieldset[data-handle="frames"] input').on("change", function () {
    let selectedFrameSize = $(this).data('frame-size') - 0;
    let selectedSizeX = $('fieldset input[name="Size"]:checked').val().split("x")[0].trim() - 0 + (selectedFrameSize);
    let selectedSizeY = $('fieldset input[name="Size"]:checked').val().split("x")[1].trim() - 0 + (selectedFrameSize);

    $('.finished-size--value').text(selectedSizeX + " x " + selectedSizeY);
  });

  $('fieldset input[name="Size"]').on('change', function () {
    let selectedFrameSize = $('fieldset input[name="Frame"]:checked, fieldset input[name="Frames"]:checked').data('frame-size') - 0;
    let selectedSizeX = $(this).val().split("x")[0]?.trim() - 0 + (selectedFrameSize);
    let selectedSizeY = $(this).val().split("x")[1]?.trim() - 0 + (selectedFrameSize);

    $('.finished-size--value').text(selectedSizeX + " x " + selectedSizeY);
  });

  // On load
  $('fieldset input[name="Frame"], fieldset input[name="Frames"]').each((index, frame) => {
    if ($(frame).is(":checked")) {
      let selectedFrameSize = $(frame).data('frame-size') - 0;
      let selectedSizeX = $('fieldset input[name="Size"]:checked').val().split("x")[0].trim() - 0 + (selectedFrameSize);
      let selectedSizeY = $('fieldset input[name="Size"]:checked').val().split("x")[1].trim() - 0 + (selectedFrameSize);

      $('.finished-size--value').text(selectedSizeX + " x " + selectedSizeY);
      
      let variantImage =  document.querySelector('.selected-varaint-image');
      //let tooltipButton = document.querySelector('#tooltip');
      let tooltipButton = document.querySelector('#about-the-frame');
      let tooltipButtonText = tooltipButton.querySelector('.text-container');
      let tooltipContent = variantImage.querySelector('img').dataset.tooltip;
      let tooltipInputContent = document.querySelector('.product-information .frame-options input[type="radio"]:checked:not(.disabled)').dataset.tooltip;

      if (tooltipButton) {
        if(tooltipContent) {
          tooltipButtonText.innerHTML = `<b>About this Frame:</b> ${tooltipContent}`;
          tooltipButton.style.display = "flex";
          /*
          tippy(tooltipButton, {
            content: `<div>
              <span class="frame-details">Frame details</span>
              <button class="tooltip-close"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M13 1L1 13M13 13L1 1" stroke="var(--color-body)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </svg></button>
              ${tooltipContent}
            </div>`,
            allowHTML: true,
            theme: 'light',
            trigger: 'click',
            interactive: true,
            maxWidth: 200,
            onShown(instance) {
              const closeBtn = instance.popper.querySelector('.tooltip-close');
              if (closeBtn) {
                closeBtn.addEventListener('click', () => instance.hide());
              }
            }
          });
          */
        } else if (tooltipInputContent) {
          tooltipButtonText.innerHTML = `<b>About this Frame:</b> ${tooltipInputContent}`;
          tooltipButton.style.display = "flex";
        } else {
          tooltipButton.style.display = "none";
        }
      }

      let frameURL = '';
      if (variantImage && variantImage.classList.contains('custom-frame')) {
        let frameSize = document.querySelector('.product-information .product-form__input[data-handle="size"] input[type="radio"]:checked:not(.disabled)').value;
        let [width, height] = frameSize.split('x').map(Number);
        let imageElement = variantImage.querySelector('img');
        let url = "";
        let z = height / width;
      
        if (z > 1.1 && z < 1.3) {
          url = imageElement.dataset.classicVertical;
        } else if (z > 0.75 && z < 0.85) {
          url = imageElement.dataset.classicHorizontal;
        } else if (z > 2.5 && z < 3.5) {
          url = imageElement.dataset.panoVertical;
        } else if (z > 0.3 && z < 0.4) {
          url = imageElement.dataset.panoHorizontal;
        } else if (z > 0.6 && z < 0.7) {
          url = imageElement.dataset.rectangleHorizontal;
        } else if (z > 1.4 && z < 1.6) {
          url = imageElement.dataset.rectangleVertical;
        } else if (z == 1) {
          url = imageElement.dataset.square;
        } else if (z > 0.4 && z < 0.6) {
          url = imageElement.dataset.storyHorizontal;
        } else {
          console.log("Wrong Size!!!");
        }

        if(url && !url.includes("assets/no-image")) {
          frameURL = url;
          variantImage.querySelector('.variant-image-frame').style.setProperty('--background-image', `url("${url}")`);
        }
      }

      var lightbox = new SimpleLightbox('.selected-varaint-image a', {
        overlayOpacity: 1,
        closeText: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M13 1L1 13M13 13L1 1" stroke="var(--color-body)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </svg>'
      });
      lightbox.on('shown.simplelightbox', function () {
        document.querySelector('.simple-lightbox .sl-image').style.setProperty('--background-image', `url("${frameURL}")`);
      });
    }

    // $(frame).on("change", () => {
    //   setTimeout(() => {
    //     $('.selected-varaint-image .image img').attr('src', $(".product-images__slide-image.is-selected img").attr('src').replace('20x20', '480x480'));
    //   }, 200);
    // })
  });

  $('input[name="Shape"]').on("change", function () {
    setTimeout(() => {
      var firstEnabledSizeInput = $('input[name="Size"]:not(.is-disabled)').first();
      $(firstEnabledSizeInput).click();
    }, 0);
  });

  if ($.cookie('scrollTop') != undefined) {
    $(window).on("load", function () {
      window.scroll(0, parseInt($.cookie('scrollTop')));

      setTimeout(() => {
        $.removeCookie('scrollTop');
      }, 1000);
    });
  }

  $(".form_options .custom-option").on("click", function () {
    $.cookie('scrollTop', $(window).scrollTop());
  });

  $(".es-order-deadline h2").on("click", function () {
    $(this).closest(".container").toggleClass("open");
  });

  $("input[name='esCustomFrame']").on("change", function () {
    $(".es-custom-frame--selected-name").text($(this).data('name'));
  });
});

const onStampedReviewsLoaded = () => {
  const widget = document.querySelector(".main-product-page .stamped-product-reviews-badge");
  
  if (widget.querySelector(".stamped-badge")) {
    const rating_count = parseFloat(widget.querySelector(".stamped-badge").dataset.rating);
  
    console.log('rating => ', rating_count);
  
    if (rating_count < 4) {
      widget.style.display = "none";
    }
  
    if (rating_count == 0) {
      document.getElementById("stamped-main-widget").style.display = "none";
    } else {
      document.getElementById("stamped-main-widget").style.display = "block";
    }
  } else {
    document.getElementById("stamped-main-widget").style.display = "none";
  }
}

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      if (document.querySelector('.main-product-page .stamped-product-reviews-badge .stamped-badge')) {
        onStampedReviewsLoaded();
        observer.disconnect();
      }
    }
  });
});

observer.observe(document.body, {
  childList: true
});